/**
 * <faq-accordion> — c-faq-dark section.
 * Scoped to its own subtree (querySelectorAll runs on `this`, not
 * `document`), so multiple instances on the same page never cross-fire.
 *
 * Purely a class toggle — the actual slide-down/up animation is CSS
 * (grid-template-rows 0fr -> 1fr on .c-faq-item__answer-wrapper, see
 * section-c-faq-dark.css). Only one item stays open at a time.
 */
class FaqAccordion extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('.c-faq-item');

    this.items.forEach((item) => {
      const question = item.querySelector('.c-faq-item__question');
      if (!question) return;
      question.addEventListener('click', () => this.toggle(item));
    });
  }

  toggle(item) {
    const wasOpen = item.classList.contains('is-open');

    this.items.forEach((other) => {
      other.classList.remove('is-open');
      const otherQuestion = other.querySelector('.c-faq-item__question');
      if (otherQuestion) otherQuestion.setAttribute('aria-expanded', 'false');
    });

    if (!wasOpen) {
      item.classList.add('is-open');
      const question = item.querySelector('.c-faq-item__question');
      if (question) question.setAttribute('aria-expanded', 'true');
    }
  }
}

customElements.define('faq-accordion', FaqAccordion);
